/** Tracks pages with relevant meta data to provide short history */
export class Ocular {
  constructor() {
    this.list = [];
  }

  /**
   * Initialise Ocular
   */
  init() {
    this.getSession();
    this.addPage();
    this.setSession();
    this.produce();
  }

  /**
   * Check whether current page is already in the tracked history
   * @param {object} obj New tracked page to test for duplicates of
   * @param {array} list Currently tracked pages
   * @param {string} field The object property to compare
   */
  static containsObject(obj, list, field) {
    for (let i = 0; i < list.length; i++) {
      if (list[i][field] === obj[field]) {
        list.splice(i, 1);
      }
    }
  }

  /**
   * Add current page to history
   */
  addPage() {
    const item = this.getPageInfo();

    if (item === null) {
      if (this.list.length >= 6) {
        this.list.splice(5, 1);
      }
    } else {
      if (this.list.length <= 5) {
        Ocular.containsObject(item, this.list, 'url');
        this.list.unshift(item);
      }
      if (this.list.length >= 6) {
        Ocular.containsObject(item, this.list, 'url');
        this.list.unshift(item);
        this.list.splice(6, 1);
      }
      if (this.list.length >= 7) {
        this.list.pop();
      }
    }
  }

  /**
   * Retrieve information about current page
   * @returns {object|null} Returns meta data about page if present, or null otherwise
   */
  getPageInfo() {
    const metas = $('meta[name^="page:"]');
    const object = {};
    $.each(metas, (index, meta) => {
      const name = $(meta).attr('name').split(':')[1];
      object[name] = $(meta).attr('content');
    });

    if ($.isEmptyObject(object)) {
      return null;
    }

    object.url = window.location.pathname;
    return object;
  }

  /**
   * Store history in localStorage
   */
  setSession() {
    localStorage.setItem('recentlyViewed', JSON.stringify(this.list));
  }

  /**
   * Retrieve history from localStorage
   */
  getSession() {
    let recentlyViewed = localStorage.getItem('recentlyViewed');
    if (typeof recentlyViewed === 'string') {
      recentlyViewed = JSON.parse(recentlyViewed);
      this.list = recentlyViewed;
    }
  }

  /**
   * Provide array of recently viewed pages
   * @returns {Array}
   */
  produce() {
    const context = this.list;

    // Remove item if on it's page
    for (let i = 0; i < context.length; i++) {
      if (context[i].url === window.location.pathname) {
        context.splice(i, 1);
      }
    }
    return context;
  }
}
